import script from "./UsuarioProximasReservasCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioProximasReservasCarousel.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioProximasReservasCarousel.vue?vue&type=style&index=0&id=8a30ef5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a30ef5c"]])

export default __exports__